module.exports = __webpack_public_path__ + "static/img/type5.746c545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type5.png
// module id = nv+Z
// module chunks = 1